import React, { useEffect, useState } from "react";
import CollapsibleContainer from '../components/collapsibleContainer';
import { useSelector, useDispatch } from "react-redux";
import { ACTIONS as DATA_ACTIONS } from "../redux/reducers/DataReducer"
import { FaSearch } from "react-icons/fa";
import Spinner from "../components/spinner";
import { Button, SubTitle, Text } from "../theme/theme";
import * as randomColor from "random-color"


const Poi = ()=>{
    const settings = useSelector(state=>state.data.data)
    const data = useSelector(state => state.data);
    const [remove, setRemove] = useState(null);

    const dispatch = useDispatch();

    useEffect(()=>{

        if(!data.poi){
            const ls = localStorage.getItem("poi");
            const res = ls?JSON.parse(ls):null;

            dispatch({type: DATA_ACTIONS.SET_POI, poi: res?res:[]})
        }

        if (remove){
            const newList = [];
            data.poi.forEach(p => {
                if (p.color !== remove){
                    newList.push(p);
                }
            });
            dispatch({type: DATA_ACTIONS.SET_POI, poi: newList})
            setRemove(null);
        }
    })

    if (data && data.planet && data.planetStore && data.poi){

        return (
            <CollapsibleContainer open title={"Points of Interest" }  icon={<FaSearch />}>
                <div style={{cursor: "pointer"}} onClick={()=>{
                    const msg = window.prompt("Make a note", "")
                    const color = randomColor().hexString();;
                    dispatch({type: DATA_ACTIONS.ADD_POI, poi: {planet: data.planet, height: data.height, coordinates: data.coordinates, msg, color} })
                }}>
                 <Button>Add Point Of Interest</Button>
                </div>
                
                <br/>
                <div style={{marginTop: "-2px", marginLeft: "-2px"}}>
                {data.poi.map(({planet, color, msg, height, coordinates})=><div style={{outline: "solid 2px black", marginTop: "2px", marginLeft: "2px", padding: "10px"}} key={color}>
                    <h3 style={{margin: "0px", padding: "0px"}}>{planet}</h3>
                    <br /> <span style={{color, background: "black", padding: "4px"}} >Color: {color}</span> <br/>
                    <b>Height:</b> {height} <br/>
                    <b>Coordinates:</b> (x: {coordinates.x}, y: {coordinates.y})
                    
                    <br/><br/>
                    <div style={{border: "dotted black 1px"}} />
                    
                    <br/><b>{msg}</b>
                    <br/><br/>

                    <div onClick={()=>{
                        setRemove(color);
                    }} style={{textDecoration: "underline", padding: "10px", color: "yellow", background: "black"}}>
                        <b>REMOVE</b>

                    </div>
                    

                </div>)}
                </div>

                

               
                
    
              
            </CollapsibleContainer>
            )
    
    } else {
        return <Spinner />
    }

    
}

export default Poi;